import InfoSnippetDecoupled from './InfoSnippetDecoupled';

export default InfoSnippetDecoupled;
